import { Component } from '@angular/core';

@Component({
  selector: 'greco-centered-container',
  templateUrl: './centered-container.layout.html',
  styleUrls: ['./centered-container.layout.scss']
})
export class CenteredContainerLayout {}
